import Dashboard from "../pages/Dashboard/Dashboard";
import Matches from "../pages/Matches/Matches";
import Players from "../pages/Players/Players";
import Highlights from "../pages/Highlights/Highlights";
import Table from "../pages/Table/Table";
import Users from "../pages/Users/User";
import CreateUser from "../pages/Users/CreateUser";
import PlayerPhoto from "../pages/PlayersPhoto/PlayerPhoto";
import ContentDashboard from "../pages/Content-Dashboard/ContentDashboard";
import MatchPanel from "../pages/MatchPanel/MatchPanel";
import MatchDetails from "../pages/MatchDetails/MatchDetails";
import AddRole from "../pages/addRoles/AddRoles";
import UsersTable from "../pages/newUserDashboard/newUser.js";
// import Login from "../pages/login/login.js";
import CompetitionsList from "../pages/competitions/editCompetitions/editCompetitions.js";
import Login from '../pages/Authentication/Login.js';
import ResetPassword from '../pages/Authentication/ResetPassword';
import AddCompetition from '../pages/competitions/addCompetitions/addCompetitions.js';
import competitionsSettings from "../pages/competitions/comepetitions.js";
import competitionTeams from "../pages/competitions/editCompetitions/editTeams.js";
import NoAccess from "../pages/Access/noAccess.js";
import Icons from "../pages/icons/icons.js";
import NotificationHistory from "../pages/Notifications/notification_history.js";
import NewInstalls from "../pages/new_installs/new_install.js";
import UrlHistory from "../pages/copy-url/copy-url.js";
import InappNotifications from "../pages/in-app-notifications/notifications.js";
import TopPosts from "../pages/topPosts/topPosts.js";
import TagsAnalytics from "../pages/Tags/TagsAnalytics.js";
import SponsoredAds from "../pages/SponsoredAds/SponsoredAds.js";
import topicDashboard from "../pages/Topics/dashboard.js";
import DailyDashboard from "../pages/daily_dashboard/daily_dashboard.js";
import CompetitionImages from "../pages/CompetitionImages/CompetitionImages.js";
import Stickers from "../pages/Stickers/Stickers.js";
import FeedTopics from "../pages/FeedTopics/FeedTopics.js";
import CreateFeed from "../pages/Feeds/CreateFeed.js";
import Memes from "../pages/Memes/Memes.js";
import PlayerMoments from "../pages/PlayerMoments/PlayerMoments.js";
import AiMatchUpdate from "../pages/AiMatchUpdate/AiMatchUpdate.js";
import AiFeedSummary from "../pages/AiFeedSummary/AiFeedSummary.js";
import GenAiControl from "../pages/GenAiControl/GenAiControl.js";
import Banners from "../pages/Banners/Banners.js";
import AiChat from "../pages/AiChat/AiChat.js";
import ApiLatency from "../pages/ApiLatency/ApiLatency.js";
import ApiResponseStats from "../pages/ApiResponseStats/ApiResponseStats.js";
import SystemHealth from "../pages/SystemHealth/SystemHealth.js";
import QuickLinks from "../pages/QuickLinks/QuickLinks.js";
import FanWarsLineup from "../pages/FanWarsLineup/FanWarsLineup.js";
import GameDashboard from "../pages/GameDashboard/GameDashboard.js";
import PredictionQuestions from "../pages/PredictionQuestions/PredictionQuestions.js";
import PredictionCandidates from "../pages/PredictionCandidates/PredictionCandidates.js";
import ArcadeParticipationForceActive from "../pages/ArcadeParticipationForceActive/ArcadeParticipationForceActive.js";
import ArcadeCompetitions from "../pages/ArcadeCompetitions/ArcadeCompetitions.js";
import AiChatCredits from "../pages/AiChatCredits/AiChatCredits.js";
import FeatureFlags from "../pages/FeatureFlags/FeatureFlags.js";
import SendNotification from "../pages/Notifications/SendNotification.js";
import ReferralDashboard from "../pages/ReferralDashboard/ReferralDashboard.js";
import ReferralCodes from "../pages/ReferralCodes/ReferralCodes.js";
import DeleteUser from "../pages/DeleteUser/DeleteUser.js";
import DummyLive from "../pages/DummyLive/DummyLive.js";
import MatchHashtagTopicsDashboard from "../pages/MatchHashtagTopicsDashboard/MatchHashtagTopicsDashboard.js";
import GenAiHub from "../pages/GenAiHub/GenAiHub.js";
import MatchCards from "../pages/GenAiHub/MatchCards.js";
import DynamicPrompts from "../pages/GenAiHub/DynamicPrompts.js";
import LanguageTest from "../pages/GenAiHub/LanguageTest.js";
import FanStoriesAdmin from "../pages/FanStoriesAdmin/FanStoriesAdmin.js";
import AiMatchSummary from "../pages/AiMatchSummary/AiMatchSummary.js";
import AiChatDashboard from "../pages/AiChatDashboard/AiChatDashboard.js";
import ReelScriptAdmin from "../pages/ReelScriptAdmin/ReelScriptAdmin.js";
import StoreDashboard from "../pages/StoreDashboard/StoreDashboard.js";
import StoreProducts from "../pages/StoreProducts/StoreProducts.js";
import StoreOrders from "../pages/StoreOrders/StoreOrders.js";
import StoreSettings from "../pages/StoreSettings/StoreSettings.js";
import StoreCategories from "../pages/StoreCategories/StoreCategories.js";
import StoreDiscounts from "../pages/StoreDiscounts/StoreDiscounts.js";
import FanVideoDashboard from "../pages/FanVideoDashboard/FanVideoDashboard.js";
import DiscoverSections from "../pages/DiscoverSections/DiscoverSections.js";
import HookQuestionsAdmin from "../pages/HookQuestionsAdmin/HookQuestionsAdmin.js";
import MorningBriefAdmin from "../pages/MorningBriefAdmin/MorningBriefAdmin.js";
import MorningBriefStudio from "../pages/MorningBriefStudio/MorningBriefStudio.js";
import FanAgents from "../pages/FanAgents/FanAgents.js";
import GenAiUsageDashboard from "../pages/GenAiUsageDashboard/GenAiUsageDashboard.js";
import GenAiMatchControls from "../pages/GenAiMatchControls/GenAiMatchControls.js";
import FanEnergyDashboard from "../pages/FanEnergyDashboard/FanEnergyDashboard.js";
import FanEnergyLeaderboard from "../pages/FanEnergyLeaderboard/FanEnergyLeaderboard.js";
import FanLedger from "../pages/FanLedger/FanLedger.js";
import CompetitionRailDashboard from "../pages/CompetitionRailDashboard/CompetitionRailDashboard.js";
import FanLoungeDashboard from "../pages/FanLoungeDashboard/FanLoungeDashboard.js";
import StreakAuditDashboard from "../pages/StreakAuditDashboard/StreakAuditDashboard.js";
import CuratedArticles from "../pages/CuratedArticles/CuratedArticles.js";
import Missions from "../pages/Missions/Missions.js";
import DailyMissions from "../pages/DailyMissions/DailyMissions.js";
import DailyTasks from "../pages/DailyTasks/DailyTasks.js";
import ReportDashboard from "../pages/ReportDashboard/ReportDashboard.js";
import SuperOverDailyChallenge from "../pages/SuperOverDailyChallenge/SuperOverDailyChallenge.js";
import SuperOverPromotions from "../pages/SuperOverPromotions/SuperOverPromotions.js";
import MindCricketLeague from "../pages/MindCricketLeague/MindCricketLeague.js";
import GameCatalog from "../pages/GameCatalog/GameCatalog.js";
import AppLanding from "../pages/AppLanding/AppLanding.js";
import SocialSeed from "../pages/SocialSeed/SocialSeed.js";
import Pulse from "../pages/Pulse/Pulse.js";
import SuperblogBuilder from "../pages/SuperblogBuilder/SuperblogBuilder.js";
import PitchWord from "../pages/PitchWord/PitchWord.js";
import PromoSurfaces from "../pages/PromoSurfaces/PromoSurfaces.js";
import FanScan from "../pages/FanScan/FanScan.js";
import Payments from "../pages/Payments/Payments.js";


const authProtectedRoutes = [
    { id:1 ,path: "/content-dashboard", component: ContentDashboard },
    { id: 2, path: "/match-panel", component: MatchPanel },
    { id: 3 , path: "/user-dashboard", component: Users },
    { id: 29, path: "/users/create", component: CreateUser },
    { id: 4, path: "/player-dashboard", component: Players },
    { id: 5, path: "/match-dashboard", component: Matches },
    { id: 6, path: "/highlights", component: Highlights },
    { id: 7, path: "/player-photo", component: PlayerPhoto },
    { id: 8, path: "/match-details", component: MatchDetails },
    { id: 9, path: "/new-user-dashboard", component: UsersTable},
    { id: 10, path: "/add-roles", component: AddRole},
    {id: 11, path: '/competitions', component: competitionsSettings},
    {id: 12, path: "/competitions/edit", component: CompetitionsList},
    {id: 13, path: "/competitions/add", component: AddCompetition},
    {id: 14, path: "/competitions/edit/:cid", component: competitionTeams},
    {id: 15, path: "/icons", component: Icons},
    {id: 16, path: "/notifications", component: NotificationHistory},
    {id: 17, path: "/new-installs", component: NewInstalls},
    {id: 18, path: "/copy-url", component: UrlHistory},
    {id: 19, path: "/inapp-notifications", component: InappNotifications},
    {id: 20, path: "/top-posts", component: TopPosts},
    {id: 21, path: "/tags-analytics", component: TagsAnalytics},
    {id: 22, path: "/sponsored-ads/*", component: SponsoredAds},
    {id: 23, path: "/topics", component: topicDashboard},
    {id: 24, path: "/daily-dashboard", component: DailyDashboard},
    {id: 25, path: "/competition-images", component: CompetitionImages},
    {id: 26, path: "/stickers", component: Stickers},
    {id: 27, path: "/feed-topics", component: FeedTopics},
    {id: 30, path: "/feeds/create", component: CreateFeed},
    {id: 31, path: "/player-moments", component: PlayerMoments},
    {id: 32, path: "/admin/match-one-liner", component: AiMatchUpdate},
    {id: 34, path: "/admin/feed-summary", component: AiFeedSummary},
    {id: 35, path: "/admin/genai", component: GenAiControl},
    {id: 68, path: "/admin/fan-stories", component: FanStoriesAdmin},
    {id: 69, path: "/admin/match-summary", component: AiMatchSummary},
    {id: 28, path: "/memes", component: Memes},
    {id: 33, path: "/banners", component: Banners},
    {id: 36, path: "/admin/ai-chat", component: AiChat},
    {id: 37, path: "/admin/api-latency", component: ApiLatency},
    {id: 46, path: "/admin/api-response-stats", component: ApiResponseStats},
    {id: 79, path: "/admin/system-health", component: SystemHealth},
    {id: 38, path: "/admin/quick-links", component: QuickLinks},
    {id: 39, path: "/admin/arcade", component: GameDashboard},
    {id: 67, path: "/admin/arcade/competitions", component: ArcadeCompetitions},
    {id: 44, path: "/admin/arcade/fanwars-lineup", component: FanWarsLineup},
    {id: 45, path: "/admin/arcade/prediction-questions", component: PredictionQuestions},
    {id: 43, path: "/admin/arcade/prediction-candidates", component: PredictionCandidates},
    {id: 56, path: "/admin/arcade/participation-force-active", component: ArcadeParticipationForceActive},
    {id: 76, path: "/admin/arcade/super-over-daily", component: SuperOverDailyChallenge},
    {id: 84, path: "/admin/arcade/super-over-promotions", component: SuperOverPromotions},
    {id: 77, path: "/admin/arcade/mind-cricket-league", component: MindCricketLeague},
    {id: 78, path: "/admin/arcade/game-catalog", component: GameCatalog},
    {id: 87, path: "/admin/arcade/pitch-word", component: PitchWord},
    {id: 89, path: "/admin/fan-scan", component: FanScan},
    {id: 41, path: "/admin/ai-chat-credits", component: AiChatCredits},
    {id: 42, path: "/admin/feature-flags", component: FeatureFlags},
    {id: 40, path: "/admin/send-notification", component: SendNotification},
    {id: 47, path: "/admin/referrals-dashboard", component: ReferralDashboard},
    {id: 72, path: "/admin/referrals/codes", component: ReferralCodes},
    {id: 88, path: "/admin/users/delete", component: DeleteUser},
    {id: 90, path: "/admin/dummy-live", component: DummyLive},
    {id: 91, path: "/admin/payments", component: Payments},
    {id: 48, path: "/admin/match-hashtag-topics", component: MatchHashtagTopicsDashboard},
    {id: 52, path: "/admin/gen-ai", component: GenAiHub},
    {id: 53, path: "/admin/gen-ai/match-cards", component: MatchCards},
    {id: 54, path: "/admin/gen-ai/dynamic-prompts", component: DynamicPrompts},
    {id: 55, path: "/admin/gen-ai/languages", component: LanguageTest},
    {id: 51, path: "/admin/ai-chat-dashboard", component: AiChatDashboard},
    {id: 166, path: "/admin/reel-script-conversations", component: ReelScriptAdmin},
    {id: 57, path: "/admin/store", component: StoreDashboard},
    {id: 58, path: "/admin/store/products", component: StoreProducts},
    {id: 59, path: "/admin/store/orders", component: StoreOrders},
    {id: 60, path: "/admin/store/settings", component: StoreSettings},
    {id: 63, path: "/admin/store/categories", component: StoreCategories},
    {id: 73, path: "/admin/store/discounts", component: StoreDiscounts},
    {id: 61, path: "/admin/fan-videos", component: FanVideoDashboard},
    {id: 62, path: "/admin/discover-sections", component: DiscoverSections},
    {id: 64, path: "/admin/hook-questions", component: HookQuestionsAdmin},
    {id: 65, path: "/admin/morning-brief", component: MorningBriefAdmin},
    {id: 167, path: "/admin/fan-agents", component: FanAgents},
    {id: 165, path: "/admin/daily-digest-studio", component: MorningBriefStudio},
    {id: 66, path: "/admin/gen-ai/usage", component: GenAiUsageDashboard},
    {id: 67, path: "/admin/gen-ai/match-controls", component: GenAiMatchControls},
    {id: 64, path: "/admin/fan-energy", component: FanEnergyDashboard},
    {id: 85, path: "/admin/fan-energy/leaderboard/*", component: FanEnergyLeaderboard},
    {id: 74, path: "/admin/fan-ledger", component: FanLedger},
    {id: 75, path: "/admin/fan-ledger/:userId", component: FanLedger},
    {id: 65, path: "/admin/competition-rail", component: CompetitionRailDashboard},
    {id: 66, path: "/admin/fan-lounge", component: FanLoungeDashboard},
    {id: 68, path: "/streak-audit", component: StreakAuditDashboard},
    {id: 69, path: "/admin/curated-articles/*", component: CuratedArticles},
    {id: 70, path: "/admin/missions/*", component: Missions},
    {id: 70, path: "/admin/daily-missions/*", component: DailyMissions},
    {id: 92, path: "/admin/daily-tasks/*", component: DailyTasks},
    {id: 71, path: "/admin/reports/*", component: ReportDashboard},
    {id: 80, path: "/admin/app-landing", component: AppLanding},
    {id: 80, path: "/admin/promo/*", component: PromoSurfaces},
    {id: 81, path: "/social-seed", component: SocialSeed},
    {id: 82, path: "/admin/social-seed", component: SocialSeed},
    {id: 83, path: "/admin/pulse/*", component: Pulse},
    {id: 86, path: "/admin/superblog", component: SuperblogBuilder},
];


const publicRoutes = [
    { path: "/dashboard", component: Dashboard },
    {path: '/dashboards', component: Dashboard},
    { path: "/login", component: Login},
    { path: "/reset-password", component: ResetPassword},
    {path: "/", component: Dashboard},
    {path: "/access-denied", component: NoAccess}

];

export { authProtectedRoutes,  publicRoutes };
